export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--T.0097f2b5.png";